var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "15", height: "15", viewBox: "0 0 15 15", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { transform: "translate(-1)", fill: "#668903", fillRule: "nonzero" },
      React.createElement("rect", { transform: "rotate(45 8.301 7.351)", x: "7.051", y: "-1.749", width: "2.5", height: "18.2", rx: "1.25" }),
      React.createElement("rect", { transform: "scale(-1 1) rotate(45 0 -12.69)", x: "7.051", y: "-1.749", width: "2.5", height: "18.2", rx: "1.25" })
    )
  );
});